import React from "react";
import { CheckCircle, XCircle, Calculator } from "@phosphor-icons/react";
import { CALC } from "@/constants/testIds";
import { useT } from "@/lib/i18n";
import { fmtMoney } from "@/lib/defaults";

export const DecisionCard = ({ lang, m, minGoal, isEmpty = false }) => {
  const t = useT(lang);
  const isP = m.is_profitable;
  const bg = isEmpty ? "bg-slate-800 dark:bg-slate-900" : isP ? "bg-emerald-600" : "bg-red-600";
  const label = isEmpty
    ? (lang === "ar" ? "بانتظار البيانات" : "Awaiting load details")
    : isP ? t("profitable") : t("notProfitable");
  const sub = isEmpty
    ? (lang === "ar"
        ? "أدخل الأميال والسعر لتحصل على قرار فوري بالربحية."
        : "Enter miles and rate to get an instant profitability verdict.")
    : isP ? t("profitableSub") : t("notProfitableSub");
  const Icon = isEmpty ? Calculator : isP ? CheckCircle : XCircle;

  return (
    <div
      data-testid={CALC.decisionCard}
      className={`${bg} text-white rounded-2xl border border-black/5 shadow-[0_10px_30px_rgba(15,23,42,0.12)] p-6 md:p-8 relative overflow-hidden`}
    >
      <div className="absolute -end-8 -top-8 w-56 h-56 rounded-full bg-white/10 blur-2xl pointer-events-none" />
      <div className="relative flex items-center gap-5 md:gap-6">
        <div className="shrink-0 w-16 h-16 md:w-20 md:h-20 rounded-2xl bg-white/15 border border-white/25 grid place-items-center pulse-glow">
          <Icon size={44} weight="fill" className="text-white" />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-[11px] uppercase tracking-[0.18em] text-white/70 font-medium">
            {t("loadDecision")}
          </p>
          <h3
            data-testid={CALC.decisionText}
            className="mt-1 text-3xl md:text-5xl font-semibold leading-none tracking-tight tabular"
          >
            {label}
          </h3>
          <p className="mt-3 text-sm md:text-base text-white/85 max-w-xl">
            {sub}
          </p>
        </div>
        <div className="hidden md:block text-end">
          <p className="text-[10px] uppercase tracking-[0.14em] text-white/70">
            {t("netProfit")}
          </p>
          <p className="text-3xl md:text-4xl font-semibold tabular mt-1">
            {isEmpty ? "—" : fmtMoney(m.net_profit)}
          </p>
          <p className="text-[11px] text-white/70 mt-1 tabular">
            {t("minProfit")}: {fmtMoney(minGoal)}
          </p>
        </div>
      </div>
    </div>
  );
};
